(function($) {
  'use strict';

  $(document).ready(function() {
    console.log('=== Script Lightbox Chargé ===');

    setTimeout(function() {

      // === Création de la lightbox si pas déjà ===
      if ($('#productLightbox').length === 0) {
        $('body').append('\
          <div id="productLightbox" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.95); z-index:9999;">\
            <button id="closeLightbox" style="position:absolute; top:20px; right:20px; background:white; border:none; padding:10px 15px; cursor:pointer; z-index:10000; border-radius:5px; font-size:18px;">✕ Fermer</button>\
            <div id="lightboxSlider" style="max-width:1200px; margin:80px auto; padding:0 50px;"></div>\
          </div>\
        ');
      }

      // === Récupération des images ===
      var productImages = [];
      $('.product-images-mosaic .mosaic-thumb').each(function() {
        var url = $(this).attr('data-zoom-image');
        if (url && productImages.indexOf(url) === -1) {
          productImages.push(url);
        }
      });

      if (productImages.length === 0) {
        console.error('❌ Aucune image trouvée pour la lightbox !');
        return;
      }

      // === Fonction d'ouverture lightbox ===
      function openLightbox(index) {

        $('#lightboxSlider').empty();

        $.each(productImages, function(i, imgUrl) {
          // $('#lightboxSlider').append('\
          //   <div style="text-align:center; padding:20px;">\
          //     <div class="lightboxSlider__slide" style="max-width:100%; max-height:95vh; height:95vh;display:block; margin:0 auto; background:url('+imgUrl+');background-repeat:no-repeat;background-size: 80%;background-position: center center;">\
          //   </div></div>\
          // ');
          $('#lightboxSlider').append('\
            <div style="text-align:center; padding:20px;">\
              <div class="lightboxSlider__slide" style="max-width:100%; max-height:95vh; height:95vh;display:block; margin:0 auto; background:url('+imgUrl+');background-repeat:no-repeat;background-size: contain;background-position: center center;">\
            </div></div>\
          ');
        });

        $('#productLightbox').fadeIn(300, function() {

          if (typeof $.fn.slick !== 'undefined') {

            if ($('#lightboxSlider').hasClass('slick-initialized')) {
              $('#lightboxSlider').slick('unslick');
            }

            $('#lightboxSlider').slick({
              initialSlide: index,
              dots: false,
              arrows: true,
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              adaptiveHeight: false,
              lazyLoad: 'ondemand',
              accessibility: true,
              prevArrow: '<button type="button" class="slick-prev">❮</button>',
              nextArrow: '<button type="button" class="slick-next">❯</button>'
            });

            // ✅ Forcer le focus clavier sur la lightbox
            $('#productLightbox').attr('tabindex', '-1').focus();

            // ✅ Activation immédiate des flèches clavier
            $(document).on('keydown.lightbox', function(e) {
              if (!$('#productLightbox').is(':visible')) return;

              if (e.key === 'ArrowRight') {
                $('#lightboxSlider').slick('slickNext');
              }

              if (e.key === 'ArrowLeft') {
                $('#lightboxSlider').slick('slickPrev');
              }
            });

            setTimeout(function() {
              $('#lightboxSlider').slick('setPosition');
            }, 50);
          }
        });
      }

      // === Ouvrir lightbox au clic sur une image de la mosaïque ===
      $(document).on('click', '.product-images-mosaic .mosaic-thumb,.lightbox-trigger', function() {
        var clickedUrl = $(this).attr('data-zoom-image');
        var index = productImages.indexOf(clickedUrl);
        if (index === -1) index = 0;
        console.log('Lightbox ouverte sur index:', index);
        openLightbox(index);
      });

      // === FERMETURE ===

      // Bouton fermer
      $(document).on('click', '#closeLightbox', function(e) {
        e.preventDefault();
        e.stopPropagation();

        $('#productLightbox').fadeOut(300, function() {
          if ($('#lightboxSlider').hasClass('slick-initialized')) {
            $('#lightboxSlider').slick('unslick');
          }

          // ✅ On retire l’écoute clavier proprement
          $(document).off('keydown.lightbox');
        });
      });

      // Clic sur le fond noir
      $(document).on('click', '#productLightbox', function(e) {
        if (e.target === this) {
          $('#productLightbox').fadeOut(300, function() {
            if ($('#lightboxSlider').hasClass('slick-initialized')) {
              $('#lightboxSlider').slick('unslick');
            }

            // ✅ On retire l’écoute clavier proprement
            $(document).off('keydown.lightbox');
          });
        }
      });

      // Empêcher la fermeture au clic sur le slider
      $(document).on('click', '#lightboxSlider, #lightboxSlider *, .slick-prev, .slick-next, .slick-dots', function(e) {
        e.stopPropagation();
      });

      // Touche Échap
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('#productLightbox').is(':visible')) {
          $('#productLightbox').fadeOut(300, function() {
            if ($('#lightboxSlider').hasClass('slick-initialized')) {
              $('#lightboxSlider').slick('unslick');
            }

            // ✅ On retire l’écoute clavier proprement
            $(document).off('keydown.lightbox');
          });
        }
      });

    }, 500);

  });


})(jQuery);
// ✅ ZOOM DYNAMIQUE AU SURVOL DES IMAGES
$(document).on('mousemove', '.lightboxSlider__slide, .mosaic-first-image', function(e) {
  var $this = $(this);

  if ($this.data('zoomed') !== true) {
    // $this.css('background-size', '160%');
    $this.css('background-size', '130%');
    $this.data('zoomed', true);
  }

  var offset = $this.offset();
  var x = ((e.pageX - offset.left) / $this.width()) * 100;
  var y = ((e.pageY - offset.top) / $this.height()) * 100;

  $this.css('background-position', x + '% ' + y + '%');
});

$(document).on('mouseleave', '.lightboxSlider__slide, .mosaic-first-image', function() {
  $(this).css({
    // 'background-size': '100%',
    'background-size': 'contain',
    'background-position': 'center center'
  });

  $(this).data('zoomed', false);
});



